import styled from "styled-components";

export const StyledSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
`;

export const StyledSwitchContainer = styled.div`
  width: 33px;
  height: 54px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--elementBackgroundTransparent);
  border-radius: 16.5px;
  justify-content: space-between;
  padding: 4px 0;
  position: relative;
  transition: background 0.2s;
`;

export const StyledSwitchHandle = styled.div`
  background: var(--fontColor);
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${({ isEditor }) =>
    !isEditor ? "0 2px 8px rgba(0,0,0,0.12)" : "0 1px 4px rgba(0,0,0,0.08)"};
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: ${({ isEditor }) => (!isEditor ? "5px" : "31px")};
  transition: top 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const StyledIconContainer = styled.div`
  height: 26px;
  width: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-top: ${({ top }) => (top ? "4px" : "0px")};
  margin-bottom: ${({ bottom }) => (bottom ? "6px" : "0px")}; */
  z-index: 1;
  color: ${({ isSelected }) => (isSelected ? "#ffffff" : "#494949")};
  transition: color 0.3s;
`;

export const StyledTextContainer = styled.div`
  display: ${({ expanded }) => (expanded ? "flex" : "none")};
  height: 54px;
  flex-direction: column;
  justify-content: space-between;
  color: var(--fontColor);
  font-size: 18px;
  white-space: nowrap;
  font-size: 12px;

  animation: appear 0.4s ease;

  @keyframes appear {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 26px;
  border-radius: 8px;
  /* background-color: ${({ selected }) => (selected ? "#f4f4f4" : "")};

  &:hover {
    background-color: #f4f4f4;
  } */

  span {
    height: 26px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`;
